/** enum for supported online meeting providers */
export enum OnlineMeetingProvider {
  MS_TEAMS = "MS_TEAMS"
}
